import styled from "@emotion/styled";

type Props = {
  id: string;
  labelText: string;
};

/**
 * 스크린리더 전용 라벨 (화면에 출력 X)
 */
export const SrLable = ({ id, labelText }: Props) => {
  return (
    <Lable htmlFor={id} id={id}>
      {labelText}
    </Lable>
  );
};

const Lable = styled.label`
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  border: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  clip-path: inset(50%);
`;
